export default __webpack_public_path__ + "static/media/concentration.34bdc37f.mp3";